import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { InvestmentGroups } from './master-master-groups-users.models';
const BASE_PATH = environment.basePath;
@Injectable({
  providedIn: 'root'
})
export class MasterMasterGroupsUsersService {

  constructor(
    private _$http: HttpClient
  ) { }

  getInvestmentGroups(payload: any) {
    return this
      ._$http
      .post<InvestmentGroups[]>(`${BASE_PATH}/bff/master/investmentGroup/viewOnly`, payload)
      .toPromise();
  }

}
